// import { useState } from "react";
// import emailjs from "emailjs-com";
import React from "react";

export const Contact = (props) => {

  return (
    <div>
      <div id="footer">
        <div className="container text-center">
          <p>
            Copyright &copy; 2024 , {" "}
            <a href="https://okscore.ai/" rel="nofollow">
            OkScore.ai ,
            </a>
             All Rights Reserved 
          </p>
          <p>
            <a href="/pt-terms-and-conditions">Termos e Condições</a> |&nbsp;
            <a href="/pt-user-agreement">Contratos de usuário</a> |&nbsp;
            <a href="/pt-privacy-policy">política de Privacidade</a>
          </p>
        </div>
      </div>
    </div>
  );
};
